module.exports = __webpack_public_path__ + "img-deploymentprocess.60d9755d8061308041b2ce1c5ef90e75.hashedasset.svg";